import type { SortOption } from '~/modules/magazine/type/filter-states';
import { NewsletterTypeEnum } from 'generated/graphql';

export const DigitalMagazineOptions = [
    { key: 'all', label: 'All' },
    {
        key: 'curated',
        label: 'Curated Collection',
        searchEnum: NewsletterTypeEnum.CuratedCollection,
    },
    {
        key: 'projectfeature',
        label: 'Project of the Month',
        searchEnum: NewsletterTypeEnum.ProjectFeature,
    },
    {
        key: 'archiprostalk',
        label: `ArchiPro's Talk`,
        searchEnum: NewsletterTypeEnum.ArchiPros,
    },
    {
        key: 'commercialedit',
        label: 'The Commercial Edit',
        searchEnum: NewsletterTypeEnum.CommercialEdit,
    },
    {
        key: 'dedicated',
        label: `Dedicated EDMs`,
        searchEnum: NewsletterTypeEnum.DedicatedEdm,
    },
    { key: 'misc', label: `Misc`, searchEnum: NewsletterTypeEnum.Misc },
] as SortOption[];

export const BASE_URL = `/digital-magazines`;
export const FILTER_API_ENDPOINT = `/remix-api/digital-magazines/get-magazine-filters`;
export const START_YEAR = 2014;
